import { Children, ReactNode, useMemo } from "react";
import useEmblaCarousel from "embla-carousel-react";
import type { EmblaOptionsType, EmblaPluginType } from "embla-carousel";
import clsx from "clsx";

type CarouselProps = {
  children: ReactNode;
  options?: EmblaOptionsType;
  plugins?: EmblaPluginType[];
  className?: string;
  containerClassName?: string;
  slideClassName?: string;
};

export function SimpleCarousel({
  children,
  options,
  plugins,
  className,
  containerClassName,
  slideClassName,
}: CarouselProps) {
  const [viewportRef] = useEmblaCarousel(options, plugins);

  //this will ensure array is not recreated on every render
  const slides = useMemo(() => Children.toArray(children), [children]);

  return (
    <div
      className={clsx("relative w-full", className)}
      role="region"
      aria-roledescription="carousel"
    >
      <div ref={viewportRef} className="overflow-hidden touch-pan-y">
        <div className={clsx("flex", containerClassName)}>
          {slides.map((child, i) => (
            <div
              key={`slide-${i}`}
              className={clsx(
                "min-w-0 shrink-0 grow-0 basis-full",
                slideClassName,
              )}
            >
              {child}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
